<template>
    <div></div>
</template>

<script>
export default {
    name: "statistics",
    data() {
        return {}
    },
    created() {
    },
    components: {},
    methods: {},
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>